import curd from '../curd'

const BASE_PATH = '/statistic/analysis'

export default curd(BASE_PATH, {
  getOCEC: data => ({
    url: `${BASE_PATH}/ocec`,
    method: 'POST',
    data
  }),
  getIofpData: data => ({
    url: `${BASE_PATH}/iofp/table`,
    method: 'POST',
    data
  }),
  getOtherData: data => ({
    url: `${BASE_PATH}/granularity/data`,
    method: 'POST',
    data
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/StatisticalAnalysis.js